export enum CookieCategory {
  STRICTLY_NECESSARY = 'C0001',
  FUNCTIONAL = 'C0002',
  PERFORMANCE = 'C0003',
  TARGETING = 'C0004',
}
